import { useState } from 'react';
import { ajaxRequest } from '../../utils/helpers';
import { redirectTo, redirectWithError } from '../../utils/redirects';

const { exchangeUrl } = window.inlineGlobalConfig;

export const useExchangeSubmit = () => {
  const [loading, setLoading] = useState(false);

  const submitExchangeRequest = ({ formValues }) => {
    const headers = {
      'Content-type': 'application/json',
    };

    setLoading(true);
    ajaxRequest('POST', `${exchangeUrl}/update`, formValues, null, false, headers)
      .then(res => {
        if (res.status === 'error') {
          redirectWithError('/exchange', res.message);
        }
        if (res.status === 'success') {
          const {
            originalOrderEntry: { link },
          } = res.data.entries.find(entry => entry.selected === true);
          redirectTo(link);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return { submitExchangeRequest, loading };
};
